export type MicrophoneErrorReason = 'denied' | 'notFound' | 'busy' | 'unknown';

const REASON_BY_ERROR_NAME: Partial<Record<string, MicrophoneErrorReason>> = {
  NotAllowedError: 'denied',
  SecurityError: 'denied',
  NotFoundError: 'notFound',
  OverconstrainedError: 'notFound',
  NotReadableError: 'busy',
  AbortError: 'busy',
};

// getUserMedia rejects with a DOMException whose message is browser-specific
// English text, so the UI relies on the standard error name instead.
export const getMicrophoneErrorReason = (
  error: unknown
): MicrophoneErrorReason => {
  const name =
    typeof error === 'object' && error !== null && 'name' in error
      ? error.name
      : undefined;

  return (typeof name === 'string' && REASON_BY_ERROR_NAME[name]) || 'unknown';
};
